<template>
  <div class="contentBox">
    <div class="login-left">
    </div>
    <div class="login-right">
      <div class="cont">
        <div class="title">
          <i class="icon icon-logo"></i>
          <p>{{loginType?'登录':'注册'}}</p>
        </div>
        <div class="login-data data2" v-if='loginType'>
          <form class="login-detail">
            <div class="login-write login-account">
              <p>登录账户</p>
              <input type="text" v-model="account" @input="numCheck(account,11,'mobile')">
            </div>
            <div class="login-write login-password">
              <p>输入验证码</p>
              <div class="codeBox">
                <input type="code" v-model="code">
                <button class="btn btn-code" @click.prevent='getCode'>{{codeTxt}}</button>
              </div>
            </div>
          </form>
          <button class="btn btn-login" @click='loginSub'>登录</button>
          <button class="btn btn-register" @click='registerShow'>注册</button>
          <div class="btnBox clear">
            <!-- <button class="btn btn-user" @click='codeSub'>使用密码登录</button> -->
            <!-- <button class="btn btn-forget" @click='forgotShow'>忘记密码？</button> -->
          </div>
        </div>
        <div class="login-data data2" v-else>
          <form class="login-detail">
            <div class="login-write login-account">
              <p>注册账户</p>
              <input type="text" v-model="account" @input="numCheck(account,11,'mobile')">
            </div>
            <div class="login-write login-password">
              <p>输入验证码</p>
              <div class="codeBox">
                <input type="code" v-model="code">
                <button class="btn btn-code" @click.prevent='getCode'>{{codeTxt}}</button>
              </div>
            </div>
          </form>
          <button class="btn btn-login" @click='registerSub'>注册</button>
          <button class="btn btn-register" @click='registerShow'>已有账户去登录</button>
        </div>
        <!-- <div class="login-data data1" v-else>
          <form class="login-detail">
            <div class="login-write login-account">
              <p>登录账户</p>
              <input type="text" v-model="account" @input="numCheck(account,11,'mobile')">
            </div>
            <div class="login-write login-password">
              <p>输入密码</p>
              <input type="password" v-model="password">
            </div>
          </form>
          <button class="btn btn-login" @click='loginSub'>登录</button>
          <div class="btnBox clear">
            <button class="btn btn-user" @click='codeSub'>使用验证码登录</button>
            <button class="btn btn-forget" @click='forgotShow'>忘记密码？</button>
          </div>
        </div> -->
      </div>
    </div>

    <div class="msgBox" v-if='forgotType'>
      <div class="contv">
        <p class="title">忘记密码</p>
        <form>
          <div class="write-txt">
            <p>账户：</p>
            <input type="text" placeholder="请输入手机号" v-model="mobile">
          </div>
          <div class="write-txt write-txt-code">
            <p>验证码：</p>
            <div class="txt">
              <input type="number" placeholder="请输入验证码" v-model="code">
              <button class="btn btn-code" @click.prevent='getCode'>{{codeTxt}}</button>
            </div>
          </div>
          <div class="write-txt">
            <p>密码：</p>
            <input type="text" placeholder="请设置新的密码" v-model="Newpassword">
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-close" style="padding: 0;" @click='forgotHide'>关闭</button>
          <button class="btn btn-sub" style="padding: 0;" @click='forgotSub'>确认</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import { register,captchaLogin,sendVerificationCode } from "@/assets/js/api";
export default {
  name: "login",
  data() {
    return {
      account: "",
      password: "",
      code:'',
      codeLogin:true,
      codeTxt:'获取验证码',
      isSendCode:false,
      countDownNum:60,
      mobile:'',
      forgotType:false,
      Newpassword:'',
      loginType:true,
    };
  },
  mounted(){
    // this.$los.los();
  },
  methods: {
    codeSub(){
      this.codeLogin = !this.codeLogin;
    },

    //获取验证码
    async getCode(){
      var that = this;
      var mobile = this.account;
      var regex = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
      if(mobile === '' || !regex.test(mobile)){
          that.$message('请输入正确的手机号码！');
          return false;
      };
      if(this.isSendCode){
          that.$message('请勿重复点击！');
          return false;
      };
      var data = {
        mobile:mobile
      };
      try {
        const response = await sendVerificationCode(data);
        if(response.code == 200){
          that.isSendCode = true;
          var setCountDown = setInterval(function() {
              that.countDownNum--;
              that.codeTxt = that.countDownNum+'s';
              if (that.countDownNum == 0) {
                  clearInterval(setCountDown);
                  that.countDownNum = 60;
                  that.isSendCode = false;
                  that.codeTxt = '重新发送';
              };
          }, 1000);
        } else {
          that.countDownNum = 60;
          that.isSendCode = false;
          that.$message(data.msg);
        }
      } catch (error) {
        that.$message(error);
        that.countDownNum = 60;
        that.isSendCode = false;
        that.$message(data.msg);
      }
    },

    // 忘记密码
    forgotShow(){
      this.forgotType = true;
      this.codeTxt = '获取验证码';
      this.isSendCode = false;
      this.countDownNum = 60;
      this.mobile = '';
      this.code = '';
    },

    // 忘记密码关闭
    forgotHide(){
      this.forgotType = false;
      this.codeTxt = '获取验证码';
      this.isSendCode = false;
      this.countDownNum = 60;
      this.mobile = '';
      this.code = '';
      this.Newpassword = '';
    },

    // 忘记密码确认
    forgotSub(){
      var that = this;
      var mobile = this.mobile;
      var code = this.code;
      var password = this.Newpassword;
      var regex = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
      if(mobile === '' || !regex.test(mobile)){
          that.$message('请输入正确的手机号码！');
          return false;
      } else if(code == ''){
          that.$message('请输入正确的验证码！');
          return false;
      } else if(password == ''){
          that.$message('请输入正确的新密码！');
          return false;
      };
      var data = {
        mobile:mobile,
        code:code,
        password:password
      }
      retrievePassword(data).then((res)=>{
        var data = res.data;
        that.$message(data.msg);
        if(data.code == 200){
          that.forgotHide();
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 登录
    async loginSub(){
      var that = this;
      if(this.account == ''){
        this.$message('请输入正确的账号！');
        return false;
      }
      if(this.code == ''){
        this.$message('请输入正确的验证码！');
        return false;
      }
      try {
        const response = await captchaLogin({account:this.account,code:this.code});
        if(response.code == 200){
          localStorage.setItem('token',response.data.token);
          that.$router.push('/resource?id=1-1');
        } else {
          that.$message(data.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    registerShow(){
      this.loginType = !this.loginType;;
    },

    async registerSub(){
      var that = this;
      try {
        const response = await register({account:this.account,code:this.code});
        if(response.code == 200){
          that.$message('请去登录！');
          that.code = '';
          that.loginType = true;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    userData(e){
      var that = this;
      if(that.$route.query.type){
        e.type = 2;
      };
      var data = JSON.stringify(e);
      localStorage.setItem('userdata',data);
      if(e.level == 0){
        that.$router.push('/open');
      } else if(e.type == 2){
        that.$router.push('/exam');
      } else {
        that.$router.push('/certificate');
      }
    },

    numCheck(e,i,type){
      var that = this;
      var num = e;
      num = num.length;
      if(num > i){
          if(type == 'mobile'){
              e = e.slice(0,11);
              that.account = e;
          } else {
              that.code = JSON.stringify(e).slice(0,4)
          }
      }
    },
  },

  
};
</script>
<style scoped>
.login-left {
  background-image: url(assets/images/login-banner.png);
  width: 50%;
  height: 100%;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.login-right {
  width: 50%;
  height: 100%;
  position: relative;
  float: right;
  background-color: #fff;
}

.login-right .cont {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.login-right .title {
  margin-bottom: 54px;
}

.login-right .title p {
  display: inline-block;
  vertical-align: top;
  font-size: 30px;
  line-height: 43px;
  height: 43px;
  color: #3d3d3d;
  font-weight: bold;
}

.icon-logo {
  width: 36px;
  height: 43px;
  background-size: 36px 43px;
  display: inline-block;
  vertical-align: top;
  margin-right: 16px;
}

.login-detail{
  font-size: 0;
}

.login-write{
  margin-bottom: 24px;
}

.login-write:last-child{
  margin-bottom: 0;
}

.login-write p{
  display: block;
  font-size: 16px;
  color: #3D3D3D;
  font-weight: 100;
}

.login-write input{
  width: 500px;
  height: 70px;
  line-height: 70px;
  border-radius: 10px;
  background-color: #F4F5F8;
  display: block;
  margin-top: 12px;
  border: none;
  font-size: 16px;
  box-sizing: border-box;
  padding: 10px 20px;
}

.login-right .btnBox{
  font-size: 0;
  margin-top: 30px;
}

.login-right .btnBox .btn{
  font-size: 16px;
  color: #6098F2;
  float: left;
}

.login-right .btnBox .btn-forget{
  float: right;
}

.btn-login{
  width: 500px;
  height: 80px;
  line-height: 80px;
  background-color: #00C7A3;
  border-radius: 10px;
  color: #fff;
  font-size: 22px;
  text-align: center;
  display: block;
  margin: 42px auto 0;
}

.data2 .login-write.login-password input{
  width: 400px;
  display: inline-block;
  vertical-align: top;
}

.data2 .login-write.login-password .codeBox .btn-code{
  width: 100px;
  display: inline-block;
  vertical-align: top;
  height: 70px;
  line-height: 70px;
  margin-top: 12px;
  text-align: center;
  color: #00C7A3;
  font-size: 16px;
}


.msgBox .contv{
  padding: 44px 120px 61px;
  box-sizing: border-box;
  border-radius: 20px;
  background-color: #fff;
}

.msgBox .contv .title{
  font-size: 24px;
  color: #3D3D3D;
  font-weight: bold;
  width: 100%;
  text-align: center;
  margin-bottom: 40px;
}

.msgBox .contv .write-txt {
  margin-bottom: 20px;
}

.msgBox .contv .write-txt p{
  display: inline-block;
  vertical-align: top;
  font-size: 16px;
  height: 64px;
  line-height: 64px;
  color: #636679;
  width: 100px;
}

.msgBox .contv .write-txt input{
  width: 400px;
  height: 64px;
  line-height: 64px;
  background-color: #F4F5F8;
  font-size: 16px;
  border-radius: 10px;
  display: inline-block;
  vertical-align: top;
  padding: 0 10px;
  box-sizing: border-box;
}

.msgBox .contv .write-txt .txt{
  display: inline-block;
  font-size: 0;
}

.msgBox .contv .write-txt .txt input{
  width: 300px;
  display: inline-block;
  vertical-align: top;
}

.msgBox .contv .write-txt .txt .btn-code{
  width: 100px;
  display: inline-block;
  vertical-align: top;
  height: 64px;
  line-height: 64px;
  color: #457AFF;
  font-size: 16px;
}

.msgBox .contv .btnBox{
  font-size: 0;
  text-align: center;
  margin-top: 30px;
}

.msgBox .contv .btnBox .btn{
  display: inline-block;
  vertical-align: top;
  width: 150px;
  height: 45px;
  line-height: 45px;
  border-radius: 30px;
  background-color: #CBCBCB;
  margin: 0 32px;
  font-size: 18px;
  color: #FFFFFF;
}

.msgBox .contv .btnBox .btn-sub{
  background-color: #457AFF;
}

.btn-register{
  color: #00C7A3;
  font-size: 22px;
  display: block;
  margin: 34px auto;
}
</style>



// WEBPACK FOOTER //
// src/login.vue